import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_TheLoading = _resolveComponent("TheLoading")
  const _component_TheLoadingMessage = _resolveComponent("TheLoadingMessage")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.isLoadingMessage)
      ? (_openBlock(), _createBlock(_component_TheLoadingMessage, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}